@use '@lib/assets/styles/main.scss' as *;
@use "@lib/components/Typography/TypographyExtends" as *;

.messageRoot {
  &.messageRootFullBottomPadding {
    padding-bottom: 8px;
  }
}

.messageRootFullWidth {
  width: 100%;
}

.message {
  position: relative;
  display: flex;
  align-items: center;
  &:not(.withActions) {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
  }
  &.withActions {
    display: grid;
    grid-template-columns: minmax(0, auto) min-content;
    grid-column-gap: 16px;
    align-items: center;
  }
  &.filledOnly {
    border-radius: 6px;
  }
  &.filledWithLeftBorder {
    border-radius: 6px;
    &.blue {
      border-left: 4px solid $blue500;
    }
    &.yellow {
      border-left: 4px solid $warning900;
    }
    &.red {
      border-left: 4px solid $error900;
    }
    &.gray {
      border-left: 4px solid $gray400;
    }
  }
  &.filledWithBorder {
    border-radius: 10px;
    &.blue {
      border: 1px solid $blue500;
    }
    &.yellow {
      border: 1px solid $warning900;
    }
    &.red {
      border: 1px solid $error900;
    }
    &.gray {
      border: 1px solid $gray400;
    }
  }
  &.transparent {
    padding: 0;
    &.withLeftIcon {
      padding-left: 20px;
    }
    &.withBigLeftIcon {
      padding-left: 40px;
      min-height: 32px;
    }
    &.blue {
      color: $blue500;
    }
    &.yellow {
      color: $warning900;
    }
    &.red {
      color: $error900;
    }
    &.gray {
      color: $gray400;
    }
  }
  &:not(.transparent) {
    padding: 12px 16px;
    min-height: 56px;
    &.withLeftIcon {
      padding-left: 44px;
    }
    &.withBigLeftIcon {
      padding-left: 56px;
    }
    &.blue {
      background-color: $blue20;
    }
    &.yellow {
      background-color: $warning100;
    }
    &.red {
      background-color: $error100;
    }
    &.gray {
      background-color: $gray10;
    }
  }
}

.leftIcon {
  position: absolute;
  .message:not(.transparent) & {
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
  }
  .message.transparent & {
    left: 0;
    top: 0;
  }
  &.iconGray {
    color: $gray400;
  }
  &.iconInner {
    .blue & {
      color: $blue500;
    }
    .yellow & {
      color: $warning900;
    }
    .red & {
      color: $error900;
    }
    .gray & {
      color: $gray400;
    }
  }
  &.filledIconWithBorder {
    border-radius: 50%;
    padding: 8px;
    .blue & {
      background-color: $blue50;
    }
    .yellow & {
      background-color: $warning200;
    }
    .red & {
      background-color: $error200;
    }
    .gray & {
      background-color: $gray100;
    }
  }
  & > * {
    display: block;
  }
}

.messageContent {
  word-break: break-word;
  p, h1, h2, h3, h4, h5, h6, ul, ol {
    margin-bottom: 8px;
  }
  ul {
    @include bodyList;
  }
}

.actions {
  display: flex;
  align-items: center;
  gap: 16px;
  white-space: nowrap;
}
